import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,

  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  
  EyeOutlined,

  SearchOutlined,
} from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getFBatches } from "../../actions/finance";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";
const { RangePicker } = DatePicker;
const { Option } = Select;
class FinanceOrderList extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    data: [],
    serviceDetails: null,
    detail: false,
    visible: false,
    passVisible: false,
    modalVisible: false,
    editModalVisible: false,
    placement: "bottom",
    id: "",
    client: null,
    batch: null,
    review: null,
    ds: null,
    de: null,
    s: null,
    payment: null,
    p: 1,
    current: 1,
  };
  componentDidMount = async () => {
    const res = await this.props.getFBatches(
      this.state.p,
      this.state.client,
      this.state.batch,
      this.state.payment,
      this.state.review,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  createData = (
    sl,
    batch_id,
    client,
    title,
    code_count,
    total_cost,
    payment_review,
    payment_status,
    created_at,
    action
  ) => {
    return {
      sl,
      batch_id,
      client,
      title,
      code_count,
      total_cost,
      payment_review,
      payment_status,
      created_at,
      action,
    };
  };

  showDrawer = (id) => {
    this.setState({
      visible: true,
      id: id,
    });
  };
  handleRefresh = async () => {
    const res = await this.props.getUsers();
    this.setState({ data: res });
  };

  handlePassVisible = (id) => {
    this.setState({ passVisible: true, id: id });
  };
  handleModalVisible = () => {
    this.setState({ modalVisible: !this.state.modalVisible });
  };
  handleVisible = async (id) => {
    history.push(`/finance-details?id=${id}`);
  };

  makeLocalTime = (date) => {
    let mainDate = date.split("T")[0];
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      mainDate + " , " + hours + ":" + minutes + " " + (am ? "a.m" : "p.m")
    );
  };

  handleDate = (date) => {
    if (date) {
      const ds = new Date(date[0]._d);
      const de = new Date(date[1]._d);
      this.setState({ ds: ds.toISOString(), de: de.toISOString() });
    } else {
      this.setState({ ds: null, de: null });
      return;
    }
  };
  handlePageChange = async (page) => {
    const res = await this.props.getFBatches(
      page,
      this.state.client,
      this.state.batch,
      this.state.payment,
      this.state.review,
      this.state.ds,
      this.state.de
    );
    this.setState({ current: page, data: res });
  };
  handleApiSearch = async () => {
    const res = await this.props.getFBatches(
      this.state.p,
      this.state.client,
      this.state.batch,
      this.state.payment,
      this.state.review,
      this.state.ds,
      this.state.de
    );
    this.setState({ data: res });
  };

  render() {
    const columns = [
      {
        title: "SL",
        dataIndex: "sl",
        key: "sl",
        width: "10%",
      },
      {
        title: "Batch ID",
        dataIndex: "batch_id",
        key: "batch_id",
        width: "15%",
        ...this.getColumnSearchProps("batch_id"),
      },
      {
        title: "Client",
        dataIndex: "client",
        key: "client",
        width: "20%",
        ...this.getColumnSearchProps("client"),
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        width: "15%",
        ...this.getColumnSearchProps("title"),
      },
      {
        title: "Code Count",
        dataIndex: "code_count",
        key: "code_count",
        width: "15%",
        ...this.getColumnSearchProps("code_count"),
      },
      {
        title: "Total Cost",
        dataIndex: "total_cost",
        key: "total_cost",
        width: "15%",
        ...this.getColumnSearchProps("total_cost"),
      },
      {
        title: "Payment Review",
        dataIndex: "payment_review",
        key: "payment_review",
        width: "20%",
        ...this.getColumnSearchProps("payment_review"),
      },
      {
        title: "Payment Status",
        dataIndex: "payment_status",
        key: "payment_status",
        width: "15%",
        ...this.getColumnSearchProps("payment_status"),
      },
      {
        title: "Created Date",
        dataIndex: "created_at",
        key: "created_at",
        width: "20%",
        ...this.getColumnSearchProps("created_at"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: "25%",
      },
    ];
    const { data } = this.state;
    const rows = [
      data?.batch
        ? data?.batch.map((item, id) =>
            this.createData(
              id + 1,
              item.batch_id,
              item.client,
              item.title,
              item.code_count,
              item.total_cost + " BDT",

              item.payment_review !== true ? (
                <Tag color="#f01e1e">&nbsp; Not Reviewed &nbsp;</Tag>
              ) : (
                <Tag color="#00798f">Reviewed</Tag>
              ),
              item.payment_status === "Paid" ? (
                <Tag color="#04836e">&nbsp; {item.payment_status} &nbsp;</Tag>
              ) : (
                <Tag color="#d36409">{item.payment_status} </Tag>
              ),
              this.makeLocalTime(item.created_at),
              <>
                <Button
                  size="small"
                  type="primary"
                  icon={<EyeOutlined />}
                  onClick={() => this.handleVisible(item.batch_id)}
                >
                  View
                </Button>{" "}
                &nbsp;
               </>
            )
          )
        : "",
    ];
    return (
      <Content >
        <Breadcrumb style={{ padding: "10px 0px" }}>
          <Breadcrumb.Item>
            <Link to="/dashboard">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Finance</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Finance List"
          subTitle="Finance Management"
          extra={<Tag color="#2db7f5" style={{fontSize:'15px',padding:'4px'}}> {data?.count} data found</Tag>}
        ></PageHeader>
        <Row>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Client Email"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ client: e.target.value })}
            />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Input
              placeholder="Batch Id"
              style={{ width: "99%" }}
              allowClear
              onChange={(e) => this.setState({ batch: e.target.value })}
            />
          </Col>

          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select payment status"
              name="payment"
              optionFilterProp="children"
              onChange={(e) => this.setState({ payment: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="unpaid">Unpaid</Option>
              <Option value="paid">Paid</Option>
            </Select>
          </Col>
          <br />
          <br />
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <Select
              showSearch
              style={{ width: "99%" }}
              placeholder="Select review status"
              name="review"
              optionFilterProp="children"
              onChange={(e) => this.setState({ review: e })}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value="">None</Option>
              <Option value="reviewed">Reviewed</Option>
              <Option value="unreviewed">Not Reviewed</Option>
            </Select>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} xl={8}>
            <RangePicker
              onChange={this.handleDate}
              format="YYYY/MM/DD"
              style={{ width: "80%" }}
            />
            &nbsp; &nbsp;
            <Tooltip title="search" onClick={this.handleApiSearch}>
              <Button type="primary" shape="circle" icon={<SearchOutlined />} />
            </Tooltip>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={rows[0]}
          scroll={{ x: 1000 }}
          sticky
          pagination={false}
        />
        <Pagination
          current={this.state.current}
          total={data?.count}
          pageSize="20"
          onChange={this.handlePageChange}
          pageSizeOptions={[20]}
        />
        
      </Content>
    );
  }
}

export default connect(null, { getFBatches })(FinanceOrderList);
